import type { PresenceUser } from '@mentimeter/editor-realtime';
import {
  Avatar,
  AVATAR_SIZE_MAP,
  CollaboratorInfo,
} from '@mentimeter/editor-ui';
import { getAvatarColor } from '@mentimeter/ragnar-ui/avatar';
import { Badge } from '@mentimeter/ragnar-ui/badge';
import { Box } from '@mentimeter/ragnar-ui/box';
import { getNameInitials } from '@mentimeter/user';
import { AVATAR_PERCENTAGE } from './PresenceAvatars';

export function EditorUserAvatar({
  id,
  presenceUser,
  isPresenting,
  onClick,
  avatarSize,
}: {
  id: string;
  presenceUser: PresenceUser;
  isPresenting: boolean;
  onClick?: ((avatar?: string | undefined) => void) | undefined;
  avatarSize: 1 | 2 | 3 | 4;
}) {
  return (
    <Box
      extend={() => ({
        width: `calc(${AVATAR_SIZE_MAP[avatarSize].width} * ${AVATAR_PERCENTAGE})`,
        zIndex: 0,
        '&:hover': {
          zIndex: 1,
        },
      })}
    >
      <Box position="relative">
        <Avatar
          size={avatarSize}
          id={id}
          initials={getNameInitials(
            presenceUser.name ? presenceUser.name : presenceUser.email,
          )}
          name={presenceUser.name}
          onAvatarClick={() => onClick && onClick(presenceUser.location)}
          profilePictureUrl={presenceUser.profile_picture_url}
          className={getAvatarColor(
            presenceUser.user_id
              ? presenceUser.user_id.toString()
              : presenceUser.device_id.toString(),
          )}
        >
          <Box alignItems="center">
            <CollaboratorInfo collaborator={presenceUser} />
          </Box>
        </Avatar>

        {isPresenting && (
          <Box
            bottom={0}
            left="20%"
            extend={() => ({
              position: 'absolute',
              transform: 'translate(-50%, 40%)',
            })}
          >
            <Badge
              compact
              type="play"
              borderStyle="solid"
              borderColor="bg"
              borderWidth={2}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
